import Boxpoint from '@/pages/Boxpoint/Template'
import Wishlist from '@/pages/Boxpoint/Wishlist'
export default {
    path: '',
    component: Boxpoint,
    children: [
        {
            path: '/wishlist',
            name: 'Wishlist',
            component: Wishlist,
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/boxpoint.js